import React from 'react';
import { integracaoEnum } from '../../../../shared/constantes/integracaoEnum';

interface DadosGeraisProps {
    nome: string;
    setNome: (v: string) => void;
    tipo: string;
    handleTipoChange: (v: string) => void;
    integracaoSelecionada: string;
    handleIntegracaoChange: (v: string) => void;
    tentativa : number;
    handleTentativaChange: (v: number ) => void;
}

const DadosGeraisCard: React.FC<DadosGeraisProps> = ({ 
    nome, setNome, tipo, handleTipoChange, integracaoSelecionada, handleIntegracaoChange , tentativa, handleTentativaChange
}) => {
    
    const opcoesDoTipo = integracaoEnum.filter(i => i.tipo === tipo);
    const disableIntegracaoSelect = !tipo || opcoesDoTipo.length <= 1;

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">Dados Gerais</div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-4">
                        <label>Tipo</label>
                        <select className="form-select" value={tipo} onChange={e => handleTipoChange(e.target.value)} required>
                            <option value="">Selecione...</option>
                            {Array.from(new Set(integracaoEnum.map(i => i.tipo))).map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label>Integração</label>
                        <select 
                            className="form-select" 
                            value={integracaoSelecionada} 
                            onChange={e => handleIntegracaoChange(e.target.value)} 
                            disabled={disableIntegracaoSelect}
                            required
                        >
                            <option value="">Selecione...</option>
                            {integracaoEnum.filter(i => i.tipo === tipo).map(i => <option key={i.integracao} value={i.integracao}>{i.integracao}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label>Nome Personalizado</label>
                        <input type="text" className="form-control" value={nome} onChange={e => setNome(e.target.value)} required placeholder="Ex: Serasa Matriz" />
                    </div>
                </div>
                {integracaoSelecionada === 'PH3A' && (
                                <div className="col-md-4">
                        <label className="form-label">Número de Tentativas</label>
                        <select 
                            className="form-select" 
                            id="tentativas" 
                            name="numero_tentativas"
                            value={tentativa}
                            onChange={e => handleTentativaChange(Number(e.target.value))}
                        >
                            {[1, 2, 3, 4, 5].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                    </div>
                    )}
            </div>
        </div>
    );
};

export default DadosGeraisCard;